var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoadPreset = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m.946 13.947 1.027.429V7.458L.11 11.948a1.547 1.547 0 0 0 .835 1.999Zm14.939-2.835-3.8-9.17A1.542 1.542 0 0 0 10.698 1c-.199 0-.406.03-.605.115L4.447 3.45a1.531 1.531 0 0 0-.827 1.992l3.8 9.17a1.53 1.53 0 0 0 1.991.828l5.639-2.337a1.528 1.528 0 0 0 .835-1.992ZM5.045 5.597a.768.768 0 0 1-.766-.767c0-.42.344-.766.766-.766.421 0 .766.345.766.766a.768.768 0 0 1-.766.767Zm-1.533 8.427c0 .842.69 1.532 1.533 1.532h1.11l-2.643-6.39v4.857Z",
  fill: "#fff"
})));
export default SvgLoadPreset;